import { useUserState } from "../store/user-store";

const useCurrentUser = () => {
  return useUserState(state => state.currentUser?.accessibleCompanies);
};

export default useCurrentUser;
